<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card>
          <v-toolbar flat dense light color="grey lighten-5">
            <v-toolbar-title>Grup-Rehber İşlemleri</v-toolbar-title>

          </v-toolbar>
          <group-modal v-if="open"/>
          <v-card-text>
            <v-flex d-flex>
              <v-btn
                color="primary"
                @click="open = !open">
                Yeni Grup Kaydı Ekle
              </v-btn>
              <!-- silmekten emin misiniz popupı -->
              <v-btn color="primary" class="ml-2" @click="dialog = true">
                Tüm Grupları Sil
              </v-btn>

              <v-dialog v-model="dialog" max-width="700px" min-width="700px">
                <v-card>
                  <v-card-title>
                    <span style="padding-bottom: 30px;"><b>UYARI !!</b></span>
                    <v-spacer></v-spacer>
                    
                    <v-alert type="warning" prominent style="padding-left:20px; word-break: break-word; 
                    table-layout:fixed;">
                       Tüm grupları kalıcı olarak silmek tehlike yaratabilir, yine de silmek istiyor musun ? 
                    </v-alert>
                  </v-card-title>
                  <v-card-actions>
                    <v-btn color="primary" text @click="deleteAll()" :loading="loadingPopup" :disabled="loadingPopup" style="margin-bottom: 10px; width: 50%; padding:25px 0px;">
                      Sil
                    </v-btn>
                    <v-btn color="error" text @click="dialog = false" style="margin-bottom: 10px; width: 50%; padding:25px 0px;">
                      İptal
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>


            </v-flex>
            <v-flex d-flex>
              <v-text-field
                v-model="search"
                label="Grupları Filtreleyin">
              </v-text-field>
            </v-flex>
            <group-datatable
              hide-actions
              :headers="headers"
              :data="filteredData"
              :loading="loading">
            </group-datatable>
            <pagination :pagination="pagination" :action="onLoad"></pagination>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
// import { downloadFile } from '../../../misc';
import GroupModal from '../../Components/Modals/GroupModal.vue';
import GroupDatatable from '../../Components/Datatables/GroupDatatable/GroupDatatable.vue';
import Pagination from '../../Components/Datatables/Pagination.vue';

export default {
  name: 'Index',
  components: { Pagination, GroupDatatable, GroupModal },
  data: () => ({
    search: '',
    dialog: false,
    loadingPopup:false,
    loader:null,
    headers: [
      { text: 'Ad', align: 'left', value: 'name'},
      { text: 'Kayıt', value: 'contacts_count', searchable: false },
      { text: 'İşlemler', value: 'actions', searchable: false },
    ],
    data: [],
    pagination: {
      current: 1,
      total: 0,
      default_list: {
        current: 1,
        total: 0,
      },
      contact_list: {
        current: 1,
        total: 0,
      },
    },
    exportData: [],
    contactsGroup: {
      data: [],
      headers: [
        { text: '#', value: 'id' },
        { text: 'Ad', align: 'left', value: 'name' },
        { text: 'Soyad', value: 'surname' },
        { text: 'Numara', value: 'number' },
        { text: 'Grup Adı', value: 'group_name' },
        { text: 'İşlemler', value: 'actions' },
      ],
    },
  }),
  created() {
    this.onLoad();
  },
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    ...mapActions(['updateModal']),
    onLoad() {
      this.send({ route: `show/groups?page=${this.pagination.current}` })
          .then((res) => {
            this.data = res.data.data.data;
            this.pagination.current = res.data.data.current_page;
            this.pagination.total = res.data.data.last_page;
            this.modalData = this.data;
          });
    },
    loadContactGroups(tabIndex) {
      if (tabIndex === 1) {
        this.send({ route: `show/contacts/all/paginate?page=${this.pagination.current}` })
        .then((res) => {
          this.contactsGroup.data = res.data.contacts.data;
          this.pagination.current = res.data.contacts.current_page;
          this.pagination.total = res.data.contacts.last_page;
        });
      }
    },
    destroyGroup(e) {
      // Silme işlemi yapan component, işini bitirdikten sonra burayı triggerlayıp,
      // reactive bir ortam oluşturacak. Burası ise bir filtreleme yapıyor.
      // silinen nesneyi data dan kaldırıyor.
      if (e.params !== 'undefined' || e.params.length > 0) {
        // eslint-disable-next-line no-return-assign
        e.params.map(param => this.data = this.data.filter(el => el.id !== param));
      }
    },
    deleteAll(){
      this.send({ route: "delete/all/groups" })
        .then((res) => {
          setTimeout(() => {
            this.onLoad()
          },600);
          this.dialog = false
        });
    },
  },

  computed: {
    ...mapFields([
      'modal.open',
      'loading',
    ]),
    ...mapFields({ modalData: 'modal.data' }),
    filteredData() {
      return this.data.filter(
          item => item.name.toLowerCase()
              .includes(this.search.toLowerCase()),
      );
    },
  },
  events: {
    'delete:group': 'destroyGroup',
    'onload:load': 'onLoad',
  },

};
</script>
